/* eslint-disable react-hooks/exhaustive-deps */
import * as app from "../../services/AppService"
import * as http from "../../services/http"
import { DatePicker, Input, Select } from "..";
import UserBranches from "../ui/UserBranches"
import React, { useEffect, useState } from "react"
import 'react-phone-input-2/lib/style.css'
import Dialog from "./Dialog";
import Cheque from "../../models/Accounting/cheque";
import { KeyValue } from "../../models/Core/key-value";

export default function ChequeDialog(props: { isInCheck?: boolean, bankPayment?: boolean, show?: boolean, onDone: (model: Cheque) => void, model: Cheque, currency: string }) {

    const [model, setModel] = useState(props.model);
    const [data, setData] = useState({
        BanksAccounts: [],
        ChecksBooks: [],
        Checks: []
    });

    useEffect(() => {
        setModel(props.model)
    }, [props.model]);

    useEffect(() => {
        if (+model.BankID === 0) return;
        http.get("/Operation/GetTotalBalance", { bankAccountId: model.BankID }, res => {
            setModel(old => ({
                ...old,
                BalanceAccount: res.AdditionalData.BalanceAccount,
                ChequeBankNonePay: res.AdditionalData.ChequeBankNonPay,
                TotalBalance: res.AdditionalData.Total,
            }))
        });
        http.get("/Operation/GetCheckBooks", { accId: model.BankID }, res => {
            setData(old => ({ ...old, ChecksBooks: res.AdditionalData }));
            if (res.AdditionalData.length > 0 && +model.ChequeBookID === 0)
                setModel(old => ({
                    ...old,
                    ChequeBookID: res.AdditionalData[0].ID,
                }))
        })
    }, [model.BankID]);

    useEffect(() => {
        if (+model.ChequeBookID === 0) return;
        http.get("/Operation/GetChecks", { checkBID: model.ChequeBookID, checkID: model.ChequeID }, res => {
            setData(old => ({ ...old, Checks: res.AdditionalData }));
            if (res.AdditionalData.length > 0 && +model.ChequeID === 0) {
                setModel(old => ({
                    ...old,
                    ChequeID: res.AdditionalData[0].ID,
                    ChequeNumber: res.AdditionalData[0].CheckNum
                }));
            }
        });
    }, [model.ChequeID, model.ChequeBookID]);

    useEffect(() => {
        app.getBankAccounts(model.ChequeBranchID, props.currency, (BanksAccounts: any) => {
            setData(old => ({ ...old, BanksAccounts }));
            if (+model.BankID === 0 && BanksAccounts.length > 0)
                bankAccountsChanged(BanksAccounts[0].Key, BanksAccounts)
        });
    }, [model.ChequeBranchID]);
    function branchChanged(ChequeBranchID: string) {
        setModel(oldModel => ({ ...oldModel, ChequeBranchID, BankID: "0", ChequeBookID: "0", ChequeID: "0" }))
        setData(old => ({ ...old, ChecksBooks: [], Checks: [] }))
    }
    function bankAccountsChanged(BankID: string, BanksAccounts: KeyValue[]) {
        setModel(oldModel => ({
            ...oldModel,
            BankID,
            BankName: app.findObjectByKey(BanksAccounts, "Key", BankID)!.Value,
            ChequeBookID: "0", ChequeID: "0"
        }))
        setData(old => ({ ...old, ChecksBooks: [], Checks: [] }));
    }
    return (
        <Dialog show={props.show} title={props.bankPayment ? "Payment" : "DataCheque"} ok={() => props.onDone(model)} size="md">
            <>
                {(props.isInCheck && !props.bankPayment) &&
                    <div className="row">
                        <div className="col">
                            <Input model={model.BankName} label="DraweeBank"
                                onChange={BankName => setModel(oldModel => ({ ...oldModel, BankName }))} />
                        </div>
                        <div className="col">
                            <Input model={model.ChequeNumber} label="NoCheck"
                                onChange={ChequeNumber => setModel(oldModel => ({ ...oldModel, ChequeNumber }))} />
                        </div>
                    </div>
                }
            </>
            <>
                {props.bankPayment &&
                    <div>

                        <div className="row">
                            <div className="col">
                                <UserBranches model={model.ChequeBranchID} onChange={branchChanged}
                                    onLoad={(branches) => { if (+model.ChequeBranchID === 0) setModel(old => ({ ...old, ChequeBranchID: branches[0].Key })) }} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <Select options={data.BanksAccounts} model={model.BankID} label="DraweeBank"
                                    onChange={bankAccountsChanged} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <Input model={model.ChequeNumber} label="NotificatNo"
                                    onChange={ChequeNumber => setModel(oldModel => ({ ...oldModel, ChequeNumber }))} />
                            </div>
                        </div>
                    </div>
                }
            </>
            <>
                {(!props.isInCheck && !props.bankPayment) &&
                    <div>

                        <div className="row">
                            <div className="col">
                                <UserBranches model={model.ChequeBranchID} onChange={branchChanged}
                                    onLoad={(branches) => { if (+model.ChequeBranchID === 0) setModel(old => ({ ...old, ChequeBranchID: branches[0].Key })) }} />
                            </div>
                            <div className="col">
                                <Select options={data.BanksAccounts} model={model.BankID} label="DraweeOnBank"
                                    onChange={bankAccountsChanged} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <Select options={data.ChecksBooks} elmKey="ID" value="NumBook" model={model.ChequeBookID} label="ChecksBook"
                                    onChange={(ChequeBookID) => setModel(oldModel => ({ ...oldModel, ChequeBookID, ChequeID: "0" }))} />
                            </div>
                            <div className="col">
                                <Select options={data.Checks} elmKey="ID" value="CheckNum" model={model.ChequeID} label="NoCheck"
                                    onChange={ChequeID => setModel(oldModel => ({
                                        ...oldModel,
                                        ChequeID,
                                        ChequeNumber: app.findObjectByKey(data.Checks, "ID", ChequeID).CheckNum
                                    }))} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <Input model={model.BalanceAccount} label="Balance" disabled />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <Input model={model.ChequeBankNonePay} label="ChecksCollection" disabled/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <Input model={model.TotalBalance} label="TotalBalance" disabled/>
                            </div>
                        </div>

                    </div>
                }
            </>
            <>
                {!props.bankPayment
                    && <div className="row">
                        <div className="col">
                            <Input model={model.ChequeBeneficiary} label="Beneficiary"
                                onChange={ChequeBeneficiary => setModel(oldModel => ({ ...oldModel, ChequeBeneficiary }))} />
                        </div>
                        <div className="col">
                            <Input model={model.ChequeOwner} label="DrawerName"
                                onChange={ChequeOwner => setModel(oldModel => ({ ...oldModel, ChequeOwner }))} />
                        </div>
                    </div>}
            </>


            <div className="row">
                <div className="col">
                    <DatePicker model={model.ChequeRelease} label={!props.bankPayment ? "DataIssued" : "TranDate"}
                        onChange={ChequeRelease => setModel(oldModel => ({ ...oldModel, ChequeRelease }))} />
                </div>
                <div className="col">
                    <DatePicker model={model.ChequeMaturity} label="DateMaturity"
                        onChange={ChequeMaturity => setModel(oldModel => ({ ...oldModel, ChequeMaturity }))} />
                </div>
            </div>

        </Dialog>
    );
}